/** Mirrors the BE enum in `src/modules/supplier-profiles/types/supplier-document-type.enum.ts`.
 * A fixed list rather than a managed dictionary: OTHER carries a free-text label, so ops is
 * never blocked waiting on a deploy to file something unusual. */
export type SupplierDocumentType = 'TRADE_LICENSE' | 'VAT_REGISTRATION_CERTIFICATE' | 'BANK_LETTER' | 'OTHER';

export const SUPPLIER_DOCUMENT_TYPE_OPTIONS: { value: SupplierDocumentType; label: string }[] = [
  { value: 'TRADE_LICENSE', label: 'Trade License' },
  { value: 'VAT_REGISTRATION_CERTIFICATE', label: 'VAT Registration Certificate' },
  { value: 'BANK_LETTER', label: 'Bank Letter' },
  { value: 'OTHER', label: 'Other…' },
];

export interface SupplierDocument {
  id: number;
  type: SupplierDocumentType;
  /** Set only for OTHER — what the document actually is. */
  customLabel: string | null;
  fileName: string;
  mimeType: string;
  fileSize: number;
  /** YYYY-MM-DD, or null for documents that do not expire (a VAT certificate typically). */
  expiryDate: string | null;
  createdAt: string;
  /** Presigned S3, ~15 min. Never cache it — a stale link fails with an S3 XML error
   * that users report as a broken file. */
  url: string;
}

export interface UploadSupplierDocumentPayload {
  supplierProfileId: number;
  type: SupplierDocumentType;
  /** Required by the BE when `type` is OTHER. */
  customLabel?: string;
  expiryDate?: string;
  file: File;
}

export interface DeleteSupplierDocumentPayload {
  supplierProfileId: number;
  documentId: number;
}
